import { StyleSheet } from 'aphrodite'

import list from './list'

export default {
  list: StyleSheet.create(list)
}



// WEBPACK FOOTER //
// ./src/components/partials/Pagination/style/index.js